import React from 'react'
import { Tag, Typography, Descriptions, Divider } from 'antd'
import {
  BranchesOutlined,
  TagOutlined,
  ClockCircleOutlined,
  CodeOutlined,
  CloudServerOutlined,
} from '@ant-design/icons'
import versionInfo from '../../version.json'
import { DEPLOY_ENV } from 'config/env'

const { Title, Text } = Typography

const ENV_CONFIG = {
  production: { color: '#f5222d', label: 'PRODUCTION', tagColor: 'red' },
  prod: { color: '#f5222d', label: 'PRODUCTION', tagColor: 'red' },
  uat: { color: '#fa8c16', label: 'UAT', tagColor: 'orange' },
  sit: { color: '#1890ff', label: 'SIT', tagColor: 'blue' },
  dev: { color: '#52c41a', label: 'DEV', tagColor: 'green' },
  development: { color: '#52c41a', label: 'DEV', tagColor: 'green' },
}

const getEnvConfig = (env) =>
  ENV_CONFIG[env?.toLowerCase()] || {
    color: '#8c8c8c',
    label: env?.toUpperCase() || 'UNKNOWN',
    tagColor: 'default',
  }

const VersionPage = () => {
  const envKey = DEPLOY_ENV
  const envCfg = getEnvConfig(envKey)

  const rows = [
    {
      icon: <CloudServerOutlined />,
      label: 'Environment',
      value: (
        <Tag color={envCfg.tagColor} style={{ fontSize: 14, padding: '2px 12px' }}>
          {envCfg.label}
        </Tag>
      ),
    },
    {
      icon: <TagOutlined />,
      label: 'Git Tag',
      value: <Text code>{versionInfo.tag}</Text>,
    },
    {
      icon: <BranchesOutlined />,
      label: 'Branch',
      value: <Text code>{versionInfo.branch}</Text>,
    },
    {
      icon: <CodeOutlined />,
      label: 'Commit',
      value: (
        <Text code title={versionInfo.commit}>
          {versionInfo.shortCommit}
          <Text type="secondary" style={{ marginLeft: 8, fontSize: 12 }}>
            {versionInfo.commit}
          </Text>
        </Text>
      ),
    },
    {
      icon: <CodeOutlined />,
      label: 'Commit Title',
      value: <Text>{versionInfo.commitTitle || 'unknown'}</Text>,
    },
    {
      icon: <ClockCircleOutlined />,
      label: 'Build Date',
      value: (
        <Text>
          {new Date(versionInfo.buildDate).toLocaleString('th-TH', {
            timeZone: 'Asia/Bangkok',
            dateStyle: 'medium',
            timeStyle: 'medium',
          })}
        </Text>
      ),
    },
  ]

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f5f5',
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 8,
          padding: '40px 48px',
          minWidth: 560,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <div
            style={{
              display: 'inline-block',
              width: 12,
              height: 12,
              borderRadius: '50%',
              background: envCfg.color,
              marginRight: 8,
              verticalAlign: 'middle',
            }}
          />
          <Title level={3} style={{ display: 'inline', verticalAlign: 'middle' }}>
            Axons Backoffice
          </Title>
        </div>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Text type="secondary">Version Information</Text>
        </div>

        <Divider />

        <Descriptions column={1} labelStyle={{ width: 120 }}>
          {rows.map(({ icon, label, value }) => (
            <Descriptions.Item
              key={label}
              label={
                <span style={{ color: '#595959' }}>
                  {icon} {label}
                </span>
              }
            >
              {value}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </div>
    </div>
  )
}

export default VersionPage
